/*************
 * algoliaSearchInsights
 * Additional events for Algolia Click and Conversion tracking
 *
 */

import aa from 'search-insights';

custom.algoliaSearchInsights = (() => {
  const productLinkClass = 'product-card__image-wrapper'; // drawerID and class
  const productTitleLinkClass = 'js-product-name'; // drawerID and class
  const collectionLinkClass = 'collection-card__image-container'; // drawerID and class
  const insightsInitiatedClass = 'js-insights-initiated';

  aa('init', {
    appId: algoliaShopify.config.app_id,
    apiKey: algoliaShopify.config.search_api_key,
    useCookie: true,
  });

  function sendEvent(eventName, objectIDs, algoliaIndexName) {
    aa('getUserToken', {}, (err, userToken) => {
      if (err) {
        return;
      }
      aa('clickedObjectIDs', {
        userToken: userToken,
        index: algoliaIndexName,
        eventName: eventName,
        objectIDs: objectIDs,
      });
    });
  }

  function setupHandlers() {
    $(`.${collectionLinkClass}`)
      .not(`.${insightsInitiatedClass}`)
      .each(function () {
        $(this).addClass(insightsInitiatedClass);
        $(this).on('click', function () {
          const objectIDs = $(this).data('object-id');
          if (!objectIDs) return;
          sendEvent(
            'Collection Link Opened',
            [objectIDs.toString()],
            window.AlgoliaIndices.collections,
          );
        });
      });
    $(`.${productLinkClass}, .${productTitleLinkClass}`)
      .not(`.${insightsInitiatedClass}`)
      .each(function () {
        $(this).addClass(insightsInitiatedClass);
        $(this).on('click', function (event) {
          if($(event.target).hasClass('js-quick-view-button')) {
            //ignore quick view clicks, button has been placed inside link which is causing double counting
            return;
          }
          const objectIDs = $(this).data('object-id');
          if (!objectIDs) return;
          sendEvent(
            'Product Link Opened',
            [objectIDs.toString()],
            window.AlgoliaIndices.products,
          );
        });
      });
  }

  function init() {
    setupHandlers();
  }
  return {
    init,
  };
})();



// WEBPACK FOOTER //
// ./src/scripts/src/custom/algolia-search-insights.js